type KeyboardBridge = {
  setResizeMode?: (options: { mode: "native" }) => Promise<void>;
  setScroll?: (options: { isDisabled: boolean }) => Promise<void>;
};

type CapacitorBridge = {
  getPlatform?: () => string;
  isNativePlatform?: () => boolean;
  Plugins?: {
    Keyboard?: KeyboardBridge;
  };
};

type CapacitorWindow = Window & {
  Capacitor?: CapacitorBridge;
};

function getCapacitorBridge(): CapacitorBridge | undefined {
  if (typeof window === "undefined") return undefined;
  return (window as CapacitorWindow).Capacitor;
}

/** Verdadeiro somente dentro do WebView nativo gerenciado pelo Capacitor. */
export function isNativeCapacitor(): boolean {
  try {
    return getCapacitorBridge()?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

async function bestEffort(action: (() => Promise<void>) | undefined): Promise<void> {
  if (!action) return;

  try {
    await action();
  } catch {
    // Configuração nativa não pode impedir o boot do app.
  }
}

/**
 * Inicializa apenas adapters nativos autorizados na C2.
 *
 * No browser e no Median esta função é um no-op. No iOS Capacitor, mantém o
 * resize nativo e o scroll normal do WebView sem alterar o layout do Chat.
 * No Android, o workaround de resize fica no capacitor.config.ts.
 */
export async function configureNativePlatform(): Promise<void> {
  const capacitor = getCapacitorBridge();
  if (!capacitor || !isNativeCapacitor()) return;

  let platform: string | undefined;
  try {
    platform = capacitor.getPlatform?.();
  } catch {
    return;
  }

  if (platform !== "ios") return;

  const keyboard = capacitor.Plugins?.Keyboard;
  await Promise.all([
    bestEffort(
      keyboard?.setResizeMode
        ? () => keyboard.setResizeMode!({ mode: "native" })
        : undefined,
    ),
    bestEffort(
      keyboard?.setScroll
        ? () => keyboard.setScroll!({ isDisabled: false })
        : undefined,
    ),
  ]);
}
